<script>
import BasePopup from '@/components/BasePopup.vue';
import colorify from '@/utils/colorify';
import htmlspecialchars from '@/utils/htmlspecialchars';

export default {
  name: 'PopupTariffLimits',
  components: { BasePopup },
  controller: null,
  data() {
    return {
      isOpened: false,
      reason: '',
    };
  },
  computed: {
    user() { return this.$store.state.auth.user; },
    desc() { return `Ваш текущий тариф [${this.user.tariff.name}]. Для продолжения работы выберите другой тариф.`; },
    descPrepared() { return colorify(htmlspecialchars.encode(this.desc)); },
  },
  methods: {
    open(message) {
      this.isOpened = true;

      const reasons = [];
      if (message.includes('Project qty overflow')) { reasons.push('количества проектов'); }
      if (message.includes('Storage overflow')) { reasons.push('объема файлового хранилища'); }

      if (reasons.length) {
        this.reason = `(превышение ${reasons.join(' и ')})`;
      }

      return new Promise((resolve, reject) => {
        this.$options.controller = { resolve, reject };
      });
    },
    close() {
      this.isOpened = false;
      this.$options.controller.resolve();
    },
    gotoTariffs() {
      this.close();
      this.$router.push({ name: 'tariffs' });
    },
  },
};
</script>

<template lang="pug">
  BasePopup(@close="close()" v-if="isOpened")
    .b-popup-tariff-limits
      ._text Это действие невозможно выполнить из-за ограничений тарифа {{reason}}
      ._desc(v-html="descPrepared")
      ._buttons
        Btn(green @click="gotoTariffs") Перейти к выбору тарифа
        Btn(blue @click="close") Отмена
</template>

<style scoped lang="scss">
.popup-tariff-limits {
  max-width: 536px;

  &__text {
    font-weight: bold;
    font-size: 18px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.02em;
    margin-bottom: 40px;
  }

  &__desc {
    letter-spacing: 0.02em;
    margin-bottom: 40px;
    text-align: center;
  }

  &__buttons {
    display: flex;
    justify-content: center;
    gap: 30px;
  }
}
</style>
